
// IF NO CONTACT ID SUBMITTED, DONT ALLOW ACCESS

window.SMTX.EasyOrder = (function () {

  if ($('.EasyOrder').length < 1) {
    return false;
  }

  if (window.contactId === undefined) {
    // Redirects if window.contactId was not posted
    window.location.replace(solutionsPlaceInstantOrderUrl);
  }

  var timeZone = window.SMTX.eo.eo_timezone;

  var API_BASE = '/api/easyorder';
  var languages,
    // Order object
    easyOrder = {
      contactId: window.contactId,
      organisationId: window.organisationId,
      organisationCountryCode: window.organisationCountryCode
    },

    // Normal Loader with a spinner
    loader = {
      message: '<img src="/static/icons/spinner.svg" class="blockUI__spinner fixed-center" width="64" height="64" />',
      centerY: false,
      centerX: false,
      css: {
        position: 'fixed',
        margin: 'auto'
      },
      overlayCSS: {
        background: '#fff',
        opacity: 0.6
      }
    };

  var _startDatePicker = null;

  var init = function () {
    if (!$('.EasyOrder').length) {
      return;
    }

    // Reset blockUI default css
    $.blockUI.defaults.css = {};

    // Places API for address
    var addressField = document.getElementById('interpretation-address');
    var options = {
      types: ['address'],
      componentRestrictions: { country: window.SMTX.eo.places_country_restriction }
    };

    // $('#interpretation-address').keydown(function (e) {
    //   if (e.keyCode === 13 || e.keyCode === '13') {
    //     log(13);
    //     e.preventDefault();
    //     return false;
    //     //autocomplete.trigger('place_changed');
    //   }
    // });


    autocomplete = new google.maps.places.Autocomplete(addressField, options);
    autocomplete.setFields(['address_components']);
    autocomplete.addListener('place_changed', function () {
      var place = autocomplete.getPlace();
      var street_number = '';
      var route = '';
      var postal_code = '';
      var postal_town = '';
      var country = '';
      var is_valid_adress = false;
      log('changed');

      if (place && place.address_components) {


        for (var i = 0; i < place.address_components.length; i++) {
          var addressType = place.address_components[i].types[0];
          //log(addressType + ':' + place.address_components[i].long_name);
          switch (addressType) {
            case 'route':
              route = place.address_components[i].long_name;
              break;
            case 'street_number':
              street_number = place.address_components[i].long_name;
              break;
            case 'postal_code':
              postal_code = place.address_components[i].long_name;
              break;
            case 'administrative_area_level_3':
              postal_town = (postal_town !== "") ? postal_town : place.address_components[i].long_name;
              break;
            case 'administrative_area_level_2':
              postal_town = (postal_town !== "") ? postal_town : place.address_components[i].long_name;
              break;
            case 'administrative_area_level_1':
              postal_town = (postal_town !== "") ? postal_town : place.address_components[i].long_name;
              break;
            case 'locality':
              postal_town = place.address_components[i].long_name;
              break;
            case 'postal_town':
              postal_town = place.address_components[i].long_name;
              break;
            case 'country':
              country = place.address_components[i].long_name;
              break;
          }
        }

        var choosen_address = '';
        if (route !== '' && street_number !== '') {
          choosen_address += route + ' ' + street_number;
        } else if (route !== '') {
          choosen_address += route;
        }

        if (postal_code !== '' && postal_town !== '') {
          choosen_address += ', ' + postal_code + ' ' + postal_town;
        } else if (postal_town !== '') {
          choosen_address += ', ' + postal_town;
        }

        if (country !== '') {
          choosen_address += ', ' + country;
        }

        addressField.value = choosen_address;

        if (postal_code !== '') {
          document.getElementById('interpretation-postal-code').value = postal_code;
        } else {
          document.getElementById('interpretation-postal-code').value = '';
        }

        if ((route && route !== '') && (street_number && street_number !== '') && (postal_code && postal_code !== '') && (postal_town && postal_town !== '')) {
          is_valid_adress = true;
        }

        //log('place changed. Valid: ' + is_valid_adress);
        if (!is_valid_adress) {
          setAddressError();
        } else {
          removeAddressError();
        }

      }else if($('input#interpretation-address').val() !== ''){
        setAddressError();
      }

    });

    $('input#interpretation-address').on('blur', function (e) {
      if($('input#interpretation-address').val() !== ''){
        google.maps.event.trigger(autocomplete, 'place_changed');
      }else{
        removeAddressError();
      }
    });


    function setAddressError() {
      //log('add error');
      $('input#interpretation-address').addClass('is-invalid-input');
      $('.book-interpreter__error-message[data-address]').addClass('is-visible');
    }

    function removeAddressError() {
      //log('rmove error');
      $('input#interpretation-address').removeClass('is-invalid-input');
      $('.book-interpreter__error-message[data-address]').removeClass('is-visible');
    }

    // Setup handlers
    $('.go-to-step').on('click', stepMenuLink);

    $('#interpretation-types').on('toggled', function (event, tab) {
      //console.log(tab);
    });

    $('#duration').on('change', durationChanged);

    $('#interpretation-types').on('change.zf.tabs', updateDeliveryType);

    // Clear specific fields on pageload to avoid problems with form validation
    $('input#interpretation-postal-code, input#interpretation-address').val('');

    $('input#interpretation-postal-code').on('input blur paste keyup', function (e) {
      $(this).val($(this).val().trim().replace(/[^0-9\.]/g, ''));
    });


    var coeff = 1000 * 60 * 5;
    var today = new Date();
    var roundedDate = new Date(Math.ceil(today.getTime() / coeff) * coeff);

    _startDatePicker = $("#start_date").flatpickr({
      enableTime: true,
      minDate: roundedDate,
      altInput: true,
      altFormat: 'YYYY-MM-DD HH:mm',
      disableMobile: true,
      // dateFormat: "Y-m-d H:i",
      dateFormat: 'YYYY-MM-DD\\\\THH:mm:ssZ',
      defaultHour: 8,
      time_24hr: true,
      locale: {
        firstDayOfWeek: 1 // start week on Monday
      },
      onChange: function (selectedDates, dateStr, instance) {
        var now = new Date();
        var selectedDate = new Date(dateStr);
        if (now > selectedDate) {
          var newRoundedMin = new Date(Math.ceil(now.getTime() / coeff) * coeff);
          instance.set("minDate", newRoundedMin);
          instance.setDate(newRoundedMin);
        }

        formatDateForEO(_startDatePicker.selectedDates[0].toJSON())
      },
      parseDate: parseDate,
      formatDate: formatDate,
    });

    // Start getting api-data we need
    blockUI(loader);

    // Block gender-container
    $('.gender-container').block({
      message: null,
      overlayCSS: {
        background: '#fff',
        opacity: 0.6
      }
    });

    updateDeliveryType(); // Make sure form is correctly validated
    apiCalls.getLanguages();
    apiCalls.getPreferredGenderIds();
  };

  var updateDeliveryType = function () {

    if ($('.delivery-type[aria-selected="true"]').data('delivery-type-id') == 22) {
      // Interpretation at an address
      //$('input#interpretation-address').prop('required', true);
      //$('input#interpretation-postal-code').prop('required', true);
    } else {
      // Removing values when changing to other tab, otherwise form doesn't validate, despite not being required
      $('input#interpretation-postal-code, input#interpretation-address').val('');
    }
  }

  var durationChanged = function () {
    if (parseInt($('#duration').val()) === 0) {
      $('.duration-other-container').slideDown();
      $('input#duration-other').prop('required', true);
    } else {
      $('.duration-other-container').slideUp();
      $('input#duration-other').prop('required', false);
    }
  };

  var validatePostalCode = function () {
    // if($('input#interpretation-postal-code').val().trim().replace(' '/g, '').length > 5) {

    // }
  }

  // Gets all available languages
  var apiCalls = {

    getLanguages: function () {
      $.ajax({
        method: "get",
        timeout: 0,
        url: '/api/easyorder/v3/entities/languages/' + easyOrder.organisationId + '/' + easyOrder.organisationCountryCode,
        contentType: "application/json",
        success: apiCallbacks.languagesLoaded,
        error: apiCallbacks.ajaxError
      });

    },

    getPreferredGenderIds: function () {
      $.ajax({
        method: "get",
        timeout: 0,
        url: '/api/easyorder/v2/entities/genders/',
        contentType: "application/json",
        success: apiCallbacks.gendersLoaded,
        error: apiCallbacks.ajaxError
      });
    },

    sendOrder: function () {
      // Prepare duration
      //log('send order');
      if (parseInt($('#duration').val()) === 0) {
        easyOrder.duration = $('#duration-other').val();
      } else {
        easyOrder.duration = $('#duration').val();
      }

      // Send final order
      var orderData = {
        "order": {
          "contactId": easyOrder.contactId,
          "languageId": easyOrder.languageId,
          "deliveryTypeId": $('.delivery-type[aria-selected="true"]').data('delivery-type-id'),
          "startDateTimeUtc": formatDateForEO(_startDatePicker.selectedDates[0].toJSON()),
          "duration": easyOrder.duration,
          "preferredInterpreterGenderId": $('#interpreter_gender').val(),
          "referenceNumber": $('input#ref_number').val().substr(0, 50),
        },
        "organization": easyOrder.organisationCountryCode,
        "organizationId": easyOrder.organisationId // received from contact/validate
      };

      if ($('.delivery-type[aria-selected="true"]').data('delivery-type-id') == 22) {
        orderData.order.address = $('input#interpretation-address').val().trim().substr(0, 255);
        orderData.order.postalCode = $('input#interpretation-postal-code').val().trim().substr(0, 6);
        orderData.order.acceptTelephone = $('#accepts-phone-intepreter').is(':checked');
        if ($.trim(orderData.order.address) == '') {
          orderData.order.address = null;
        }
        if ($.trim(orderData.order.postalCode) == '') {
          orderData.order.postalCode = null;
        }
      }

      // Add optional data if applicable
      if ($('#additional_info').val().length > 0) {
        orderData.order.extraInformation = $('#additional_info').val().trim().substr(0, 3000);
      }

      if ($('input#first_name').val().length > 0 || $('input#last_name').val().length > 0 || $('input#id_number').val().length > 0) {
        orderData.order.client = {
          "firstName": $('input#first_name').val().trim().substr(0, 80),
          "lastName": $('input#last_name').val().trim().substr(0, 80),
          "id": $('input#id_number').val().trim().substr(0, 80)
        };
      }

      blockUI(loader);
      $.ajax({
        method: "POST",
        timeout: 0,
        url: API_BASE + '/v2/order/create',
        contentType: "application/json",
        data: JSON.stringify(orderData),
        success: apiCallbacks.orderConfirmation,
        error: apiCallbacks.ajaxError
      });
    }
  };

  var apiCallbacks = {
    // Step1 - Load all languages
    languagesLoaded: function (e) {
      // Set global data
      var languages;
      var siteLang = (window.siteLanguage) ? window.siteLanguage : 'en';
      var data = JSON.parse(e);

      if (data[0].languageNames !== undefined) {
        // Get language node
        for (var i = 0, il = data.length; i < il; i++) {
          if (data[i].language == siteLang) {
            languages = data[i].languageNames;
            break;
          }
        }
      } else {
        languages = data;
      }

      if (languages === undefined) {
        if (data.length > 0 && data[0] !== undefined && data[0].languageNames !== undefined) {
          // If not possible to find the chosen siteLanguage, get the first one in the list
          languages = data[0].languageNames;
        } else {
          // Display error if nothing works
          alert('Something went wrong while displaying the languages.');
          return false;
        }
      }

      //sort languages by name
      languages.sort(function (a, b) {
        return a.name.localeCompare(b.name)
      });

      // Populate to select box
      $('select#from-language').html('');
      // Loop all languages
      for (var i = 0, il = languages.length; i < il; i++) {
        var lang = languages[i];
        // Only output if displayable
        if ((lang.languageId !== undefined && lang.name !== undefined && lang.name.length > 0) && (lang.languageId + "") !== window.SMTX.eo.default_from_lang) {
          // Create language nodes
          $('select#from-language').append(
            '<option value="' + lang.languageId + '">' +
            lang.name + // Name visible in dropdown
            '</option>'
          );
        }
      }

      $('select#from-language').val([]);

      //language select to seearchable select2
      $('select#from-language').select2({
        placeholder: window.SMTX.eo.from_lang_placeholder
      });

      unblockUI();
    },

    gendersLoaded: function (e) {
      var data = JSON.parse(e);

      // Populate select box
      $('select#interpreter_gender').html('');

      for (var i = 0, il = data.length; i < il; i++) {
        if (data[i].language.toLowerCase() == window.SMTX.eo.genders_lang_id) {
          var genders = data[i].genders;
          for (var j = 0, jl = genders.length; j < jl; j++) {
            $('select#interpreter_gender').append(
              '<option value="' + genders[j].id + '">' + genders[j].name + '</option>'
            );
          }
          break;
        }
      }
      $('.gender-container').unblock();
    },

    orderConfirmation: function (data, textStatus, xhr) {
      // Show Thank-You-Page
      data = JSON.parse(data);
      if (data && data.orderId) {
        var $confTextObj = $('[data-confirmation-text]');
        //log($confTextObj);
        var confText = $confTextObj.text();
        //log(confText);
        confText = confText.replace('{order_number}', data.orderId);
        //log(confText);
        $('[data-confirmation-text]').text(confText);
      }
      unblockUI();
      activateStep(5);
    },

    ajaxError: function (xhr, textStatus, err) {
      // console.log('xhr', xhr);
      // console.log('statusText', textStatus);
      // console.log('err', err);
      alert('An error occured, we are unable to process your request. Please try again later.')
      unblockUI();
    },
  };

  function formatDateForEO(date) {
    //need to reset seconds to 00 due to some browsers and EO API cannot handle it??
    // Format to UTC
    var new_date = new Date(date);
    new_date.setSeconds(00);

    var formatted_date = moment.tz([
      new_date.getFullYear(),
      new_date.getMonth(),
      new_date.getDate(),
      new_date.getHours(),
      new_date.getMinutes(),
      new_date.getSeconds()
    ], timeZone).utc().format();//formatDate(new_date);

    return formatted_date;
  }

  function parseDate(dateString, format) {
    var timezonedDate = moment.tz(dateString, format, timeZone);

    return new Date(
      timezonedDate.year(),
      timezonedDate.month(),
      timezonedDate.date(),
      timezonedDate.hour(),
      timezonedDate.minute(),
      timezonedDate.second()
    );
  }
  function formatDate(date, format) {
    return moment.tz([
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds()
    ], timeZone).format(format);
  }

  // Method the sub-menu, allows going between steps
  var stepMenuLink = function (e) {
    e.preventDefault();

    var step = ($(this).data('step')) ? $(this).data('step') : 1; // Get data-step, or default to 1
    showStep(step);
  };

  var activeStepClass = 'EasyOrder__steps__step--active';
  var activateStep = function (step) {
    // Get element
    stepElem = $('.EasyOrder__steps__step[data-step="' + step + '"]');

    stepElem.addClass(activeStepClass).siblings('.' + activeStepClass).removeClass(activeStepClass);

    scrollToPos(0);
  };

  var scrollToPos = function ($pos) {
    var scrollEvents = "scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove";

    // Reset animated scroll if it's already animating
    $("html, body").stop();
    $("html, body").off(scrollEvents);

    // Scroll to position $pos
    $("html, body").on(scrollEvents, function () {
      $("html, body").stop(); // Stop scrolling if we scroll while scrollTop is animating
    });

    $("html, body").animate({ scrollTop: $pos }, 300, function () {
      $("html, body").off(scrollEvents);
    });
  };

  var validateStep = function (step) {
    //log('validate');
    // Return false if a step doesn't validate
    if (step > 1) {
      if ($('#from-language').val() && !isNaN($('#from-language').val())) {
        easyOrder.languageId = $('#from-language').val();
      } else {
        return false;
      }
    }

    if (step > 2) {
      // Determine if user_details form are validating
      $('form.translation-details').foundation('validateForm');

      // Check if any fields are invalid
      if ($('.is-invalid-input', 'form.translation-details').length) {
        scrollToPos($('.is-invalid-input').first().offset().top - $('.top-menu').outerHeight() - 45);
        return false;
      }

      //double chgeck min date due to time spent on page since choosing date
      var fp = document.querySelector("#start_date")._flatpickr;
      var now = new Date();

      if (fp.selectedDates[0] < now) {
        $("#start_date").addClass('is-invalid-input');
        scrollToPos($('.is-invalid-input').first().offset().top - $('.top-menu').outerHeight() - 45);
        var coeff = 1000 * 60 * 5;
        var newRoundedMin = new Date(Math.ceil(now.getTime() / coeff) * coeff);
        fp.set("minDate", newRoundedMin);
        fp.toggle();
        alert('Your selected start time has expired, please select a new start time to proceed');

        return false;
      }
    }

    //return false;
    return true;
  };

  // Main method for changing which "step" you are on
  var showStep = function (step) {
    // Logic for step activation
    $('.StepsMenu__link', '.StepsMenu--main').removeClass('StepsMenu__link--completed, StepsMenu__link--active');

    // Verify step changes
    if (step == 1) { // No validation needed
      $('.StepsMenu--main').removeClass('StepsMenu--show');
      activateStep(step);
    } else if (validateStep(step)) { // Needs step validation for continuing

      if (step == 2) {
        // Setup main-menu
        $('.StepsMenu--main').addClass('StepsMenu--show');
        $('.StepsMenu__link[data-step="1"]', '.StepsMenu--main').addClass('StepsMenu__link--completed');
        $('.StepsMenu__link[data-step="2"]', '.StepsMenu--main').addClass('StepsMenu__link--active');

        // Display form
        activateStep(step);
      } else if (step == 3) {

        $('.StepsMenu--main').removeClass('StepsMenu--show');
        // block UI and send order
        blockUI(loader);
        apiCalls.sendOrder();
      }
    }
  };

  var getLanguageName = function (val) {
    for (var i = 0, il = languages.length; i < il; i++) {
      if (languages[i].id == val) {
        return languages[i].name;
      }
    }
    return "";
  };

  var blockUI = function (settings) {
    // $('.EasyOrder').block(settings);

    $.blockUI(settings);
  };

  var unblockUI = function () {
    // $('.EasyOrder').unblock();
    $.unblockUI();
  };

  init();
})();
